<template>
  <div style="width: 100%; height: 100%; overflow:auto;">
<!---------------------------------------------------建单工站---------------------------------------------------->
    <frame-form v-if="parentData.station_id === 'create_order' " ref="form" :parent-data="buItemData"
                :readonly="true" component-param="bu_cs_task_add" :init-data="initData" />
    <!---------------------------------------------------收货工站---------------------------------------------------->
    <frame-form v-if="parentData.station_id === 'receive' " ref="form" :parent-data="buItemData"
                :readonly="true" component-param="station_receive_detail" :init-data="initData" />
    <!---------------------------------------------------录单工站---------------------------------------------------->
    <frame-form v-if="parentData.station_id === 'input' " ref="form" :parent-data="buItemData"
                :readonly="true" component-param="station_input"  :init-data="initData" />
    <div v-if="parentData.station_id === 'identify_assign' " style="width: 80%;margin-top: 10px;margin-left: 10px;" >
      <!---------------------------------------------------定损派单工站---------------------------------------------------->
      <div style="width: 80%">最终定损人员：{{buItemData.final_identify_user_name}}</div>
    </div>
    <!---------------------------------------------------定损工站---------------------------------------------------->
    <div v-if="parentData.station_id === 'identify' " style="margin:20px 10px 0 10px;" >
      <div v-for="(item,index) in troubleList" class="trouble-item">
        <div class="title">
          <span>{{ '定损故障' + (index + 1) }}</span>
        </div>
        <FrameForm :readonly="true" :ref="'item_'+index" component-param="station_identify_trouble"
                   :init-data="item"/>
      </div>
    </div>
    <!---------------------------------------------------配料工站---------------------------------------------------->
    <div v-if="parentData.station_id === 'batching'">
      <div v-for="trouble in batchingList" :key="trouble.trouble_id"
           style="border: solid 1px #d7dade;margin: 0 20px 20px 20px;">
        <FrameForm :ref="'frameForm'+trouble.trouble_id" component-param="bu_batching" :init-data="trouble" :parent-data="trouble" v-if="trouble"/>
      </div>
    </div>
    <!---------------------------------------------------维修派单工站---------------------------------------------------->
    <div v-if="parentData.station_id === 'repair_assign'" style="width: 80%;margin-top: 10px;margin-left: 10px;" >
      <div style="width: 80%">最终维修人：{{buItemData.final_repair_user_name}}</div>
    </div>
    <!---------------------------------------------------维修工站---------------------------------------------------->
    <frame-form v-if="parentData.station_id === 'repair'" ref="form" :parent-data="buItemData"
                :readonly="true" component-param="station_repair" :init-data="initData" />
    <!---------------------------------------------------测试工站---------------------------------------------------->
    <frame-form v-if="parentData.station_id === 'test'" ref="form" :parent-data="buItemData"
                :readonly="true" component-param="station_test_readonly" :init-data="initData" />
    <!---------------------------------------------------外观工站---------------------------------------------------->
    <frame-form v-if="parentData.station_id === 'vi'" ref="form" :parent-data="buItemData"
                :readonly="true" component-param="station_vi" :init-data="initData" />
    <!---------------------------------------------------飞测工站---------------------------------------------------->
    <frame-form v-if="parentData.station_id === 'fly'" ref="form" :parent-data="buItemData"
                :readonly="true" component-param="station_fly" :init-data="initData" />
    <!---------------------------------------------------烧机工站---------------------------------------------------->
    <frame-form v-if="parentData.station_id === 'burn_in'" ref="form" :parent-data="buItemData"
                :readonly="true" component-param="station_burn_in" :init-data="initData" />
    <!---------------------------------------------------OQC工站---------------------------------------------------->
    <div v-if="parentData.station_id === 'oqc'" style="width: 90%" >
      <el-form style="width: 90%;margin-left: 20px;margin-top: 20px" label-width="150px">
        <el-form-item label="产品确认:">
          <el-radio-group v-model="initData.product" disabled>
            <el-radio value="ok">OK</el-radio>
            <el-radio value="ng">NG</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="外观确认:">
          <el-radio-group v-model="initData.product_vi" disabled>
            <el-radio value="ok">OK</el-radio>
            <el-radio value="ng">NG</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="附件确认:" >
          <el-row style="width: 90%;">
            <el-col :span="6" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">附件</el-col>
            <el-col :span="6" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">寄送数量</el-col>
            <el-col :span="6" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">收货数量</el-col>
            <el-col :span="6" style="text-align:center;border: solid 1px #d7dade;background-color: #c5c6c7;">确认</el-col>
          </el-row>
          <div v-for="appendix in initData.appendixList" :key="appendix.id" style="width: 90%;">
            <el-row >
              <el-col :span="6" style="text-align:center;">{{ appendix.appendix_type_name }}</el-col>
              <el-col :span="6" style="text-align:center;">{{appendix.appendix_cnt}}</el-col>
              <el-col :span="6" style="text-align:center;">{{appendix.appendix_receive_cnt}}</el-col>
              <el-col :span="6" style="text-align:center;">
                <el-radio-group v-model="appendix.appendix_result" disabled>
                  <el-radio value="ok">OK</el-radio>
                  <el-radio value="ng">NG</el-radio>
                </el-radio-group>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item label="照片:" required>
          <FrameItem v-model="initData.image_ids" :item = item :file-list="initData['file@image_ids']" ></FrameItem>
        </el-form-item>
        <el-form-item label="OQC结果:">
          <el-select v-model="initData.result" placeholder="请选择OQC结果" clearable style="width: 34%" disabled>
            <el-option v-for="item in results" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

    </div>
    <!---------------------------------------------------包装工站---------------------------------------------------->
    <frame-form v-if="parentData.station_id === 'pack'" ref="form" :parent-data="buItemData"
                :readonly="true" component-param="station_pack" :init-data="initData" />


  </div>
</template>

<script>
export default {
  name: "StationDetail",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },

  data() {
    return {
      initData:{},
      buItemData:{},
      troubleList:[],
      batchingList:[],
      buItemAppendix:[],
      item:{
        component: 'take_photo',
        data_key: 'image_ids',
        limit: 10,
        label: '照片',
        readonly:true
      }
    }
  },
  computed: {
    results() {
      return this.$store.getters['core/getDictList']('station_oqc_result');
    },
  },


  async created() {
    await this.getBuItemData();
    await this.getInitData();

  },

  methods: {
    async getInitData() {
      let params = {
        station_log_id:this.parentData.id,
      }
      let stations = ['create_order','receive','input','repair','test','vi','fly','burn_in','oqc','pack'];
      if(stations.includes(this.parentData.station_id)) {
        this.initData = await this.$http('buItemStationService.getStationSubmitData', params);
        await this.$refs.form.initForm()
      }
      if(this.parentData.station_id === 'identify'){
        await this.getTroubleList()
      }
      if(this.parentData.station_id === 'batching'){
        await this.getRepairPlanList()
      }
    },
    //获取定损工站信息
    async getTroubleList(){
      let params = {
        itemId:this.parentData.item_id,
      }
      this.troubleList = await this.$http("buItemStationService.getIdentifyInfo",params);
    },

    //获取配料工站
    async getRepairPlanList() {
      this.repairPlan = await this.$http('buItemService.getRepairPlanList', {item_id: this.parentData.item_id,})
      if (this.repairPlan){
        this.batchingList = this.repairPlan.trouble_list
      }
    },


    //获取buItem数据
    async getBuItemData(){
      this.buItemData = await this.$http('baseDsService.getBuItemById',{item_id:this.parentData.item_id})
    },
  }
}
</script>

<style scoped>

.trouble-item {
  border: 1px solid #ddd;
  margin-bottom: 10px;
  margin-left: 10px;
  margin-right: 10px;

.title {
  background-color: #ddd;
  padding: 5px 0 5px 10px;
  font-weight: bold;
}
}

</style>